export default {
  admiral: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-63',
    affiliateUserId: 19773,
    showPartnerModal: true,
    modalShowLogo: true,
    displayName: 'Admiral',
    logoPath: '/img/admiral/logo.png',
		useModelV3: true,
  },
  autovillage: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-22',
    affiliateUserId: 1664,
    showPartnerModal: true,
    modalShowLogo: true,
    displayName: 'AutoVillage',
    logoPath: '/img/autovillage/logo.png',
		useModelV3: true,
  },
  autovolo: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-41',
    affiliateUserId: 16588,
    showPartnerModal: false,
    modalShowLogo: true,
    displayName: 'Autovolo',
    logoPath: '/img/autovolo/logo.png'
  },
  allpurposeloans: {
    prePopulateForm: true,
    affiliateUserId: 21723,
    showPartnerModal: false,
    modalShowLogo: true,
    displayName: 'AllPurposeLoans',
    logoPath: '/img/allpurposeloans/logo.png'
  },
  aspiremoney: {
    prePopulateForm: true,
    modalShowLogo: true,
    displayName: 'Aspire Money',
    logoPath: '/img/aspiremoney/logo.svg'
  },
  carcraft: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-29',
    loadVehicleFromQuote: false,
    affiliateUserId: 2655,
    showPartnerModal: false,
    modalShowLogo: true,
    displayName: 'CarCraft',
    logoPath: '/img/carcraft/logo.png'
  },
  ckdirect: {
    prePopulateForm: true,
    affiliateUserId: 41183,
    showPartnerModal: false,
    modalShowLogo: true,
    displayName: 'Credit Karma',
    logoPath: '/img/ckdirect/ckdirect.png',
    logoSize: {
      w: '100px',
      h: 'auto'
    }
		//theme: 'ckdirect'
  },
  creditkarma: {
    prePopulateForm: true,
    affiliateUserId: 20676,
    showPartnerModal: false,
    modalShowLogo: true,
    displayName: 'Credit Karma',
    logoPath: '/img/ckdirect/ckdirect.png',
    logoSize: {
      w: '100px',
      h: 'auto'
    }
  },
	comparethemarket: {
		prePopulateForm: true,
		affiliateUserId: 21174,
		showPartnerModal: false,
		modalShowLogo: true,
		displayName: 'Compare The Market',
		logoPath: '/img/comparethemarket/logo.svg',
		useModelV3: false,
		//swapLogo: true,
		//powerbyLogo: true,
		//theme: 'comparethemarket',
		//customIntro: true
	},
  carfinderscotland: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-42',
    affiliateUserId: 16568,
    showPartnerModal: true,
		useModelV3: true,
    displayName: 'Car Finder Scotland',
    logoPath: '/img/carfinderscotland/logo.png',
    modalShowLogo: true
  },
  cargurus: {
    prePopulateForm: false,
    affiliateUserId: 21617,
    showPartnerModal: true,
    displayName: 'CarGurus',
		useModelV3: true,
    logoPath: '/img/cargurus/logo.png',
    modalShowLogo: true
  },
  carsite: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-25',
    affiliateUserId: 2515,
    showPartnerModal: true,
		useModelV3: true,
    displayName: 'CarSite',
    logoPath: '/img/carsite/logo.jpg',
    modalShowLogo: true
  },
  cazana: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-55',
    affiliateUserId: 18796
  },
  clearscore: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-47',
    affiliateUserId: 17253,
    powerbyLogo: true,
    swapLogo: true,
    displayName: 'ClearScore',
    logoPath: '/img/clearscore/clear-score-logo.png',
		theme: 'clearscore',
    themeColor: '#233143'
  },
  confused: {
    companyName: 'Confused.com',
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-57',
    affiliateUserId: 19249,
    displayName: 'Confused',
    logoPath: '/img/confused/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  credability: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-71',
    affiliateUserId: 20123,
    displayName: 'CredAbility',
    logoPath: '/img/credability/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  credapp: {
    prePopulateForm: false,
    affiliateUserId: null
  },
  desperateseller: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-53',
    loadVehicleFromQuote: true,
    affiliateUserId: 18782,
    showPartnerModal: true,
		useModelV3: true,
    displayName: 'DesperateSeller',
    logoPath: '/img/desperateseller/logo.png',
    modalShowLogo: true
  },
  experian: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-38',
    affiliateUserId: 1798,
    showPartnerModal: false,
    modalShowLogo: true,
    powerbyLogo: true,
    swapLogo: true,
    displayName: 'Experian',
    logoPath: '/img/experian/exp.png',
    theme: 'experian',
    themeColor: '#1d4f91'
  },
	'experian-submission': {
		prePopulateForm: true,
		googleAnalytics: 'UA-219881-38',
		affiliateUserId: 1798,
		showPartnerModal: false,
		modalShowLogo: true,
		displayName: 'Experian',
		logoPath: '/img/experian/exp.png',
		theme: 'experian',
    themeColor: '#1d4f91'
	},
	experianlimited: {
		prePopulateForm: true,
		googleAnalytics: 'UA-219881-38',
		affiliateUserId: 42465,
		powerbyLogo: true,
		swapLogo: true,
		showPartnerModal: false,
		modalShowLogo: true,
		displayName: 'Experian',
		logoPath: '/img/experian/exp.png',
		theme: 'experian',
    themeColor: '#1d4f91'
	},
	everythingfinancial : {
		prePopulateForm: true,
		affiliateUserId: 41932,
		displayName: 'Everything Financial ',
		logoPath: '/img/everythingfinancial/everything-financial.jpg'
	},
  facebook: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-56',
    affiliateUserId: null,
    showPartnerModal: true,
		useModelV3: true,
  },
  freedomfinance: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-52',
    affiliateUserId: 3550,
    displayName: 'Freedom Finance',
    logoPath: '/img/freedomfinance/logo.png',
    modalShowLogo: true,
    showPartnerModal: true,
		useModelV3: true,
  },
	gocompare: {
		prePopulateForm: true,
		affiliateUserId: 21175,
		showPartnerModal: false,
		modalShowLogo: true,
		displayName: 'Go Compare',
		logoPath: '/img/gocompare/logo.svg',
		useModelV3: false,
	},
  gowizard: {
    prePopulateForm: false,
    affiliateUserId: null,
    showPartnerModal: true,
    displayName: 'GoWizard',
    logoPath: '/img/gowizard/logo.png',
    modalShowLogo: true,
		useModelV3: true,
  },
  honestjohn: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-44',
    affiliateUserId: 17094,
    displayName: 'Honest John',
    logoPath: '/img/honestjohn/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  knowyourmoney: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-54',
    affiliateUserId: 18781
  },
  money: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-61',
    affiliateUserId: 2428
  },
  moneyguru: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-67',
    affiliateUserId: 16758,
    displayName: 'Money Guru',
    logoPath: '/img/moneyguru/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  moneysupermarket: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-16',
    affiliateUserId: 20351,
    displayName: 'MoneySuperMarket',
    logoPath: '/img/moneysupermarket/logo.jpg',
    powerbyLogo: true,
    swapLogo: true,
    showPartnerModal: false,
    modalShowLogo: true,
    theme: 'moneysupermarket',
    themeColor: '#7a3f9d'
  },
  moneysavingexpert: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-16',
    affiliateUserId: 20564,
    displayName: 'MoneySavingExpert',
    logoPath: '/img/mse/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  monevo: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-16',
    affiliateUserId: 17137,
    displayName: 'Monevo',
    logoPath: '/img/monevo/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  motivfinance: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-47',
    affiliateUserId: 21430,
    displayName: 'Motiv',
    logoPath: '/svg/logos/motiv-logo.svg'
  },
  motors: {
    companyName: 'Motors.co.uk Limited',
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-40',
    loadVehicleFromQuote: true,
    affiliateUserId: 2775,
    displayName: 'Motors',
    logoPath: '/img/motors/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  oceancar: {
    prePopulateForm: false,
    affiliateUserId: 21884
  },
  oceanfinance: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-72',
    affiliateUserId: 20124,
    displayName: 'Ocean Finance',
    logoPath: '/img/oceanfinance/logo.png',
    showPartnerModal: false,
    modalShowLogo: true,
    showBanner: false,
    bannerMessage: '&#127881;&#128663; Your chance to win £7,000 in our prize draw when you successfully take out car finance with Car Finance 247, don\'t miss out!!! &#127882; <a href=\'https://www.carfinance247.co.uk/blog-post/ocean-finance-prize-draw-full-terms-and-conditions\' target=\'_blank\'>T&Cs apply</a>',
    bannerColor: '#604dd5'
  },
  parkers: {
    companyName: 'Parkers.co.uk Limited',
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-48',
    loadVehicleFromQuote: true,
    affiliateUserId: 17447,
    showPartnerModal: true,
    displayName: 'Parkers',
    logoPath: '/img/parkers/logo.png',
    modalShowLogo: true,
		useModelV3: true
  },
  raccars: {
    companyName: 'RAC Cars',
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-45',
    affiliateUserId: 17177,
    displayName: 'RAC Cars',
    logoPath: '/img/raccars/logo.webp',
    showPartnerModal: false,
    modalShowLogo: true
  },
  usedcarsni: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-31',
    affiliateUserId: 1327,
    displayName: 'Used Card NI',
    logoPath: '/img/usedcarsni/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  uswitch: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-21',
    affiliateUserId: 2411,
    displayName: 'uSwitch',
    logoPath: '/img/uswitch/logo.png',
    showPartnerModal: false,
    modalShowLogo: true
  },
  time4leasing: {
    prePopulateForm: false,
    googleAnalytics: 'UA-219881-16',
    affiliateUserId: null, // TODO - set
    displayName: 'Time4Leasing',
    logoPath: '/img/time4leasing/logo.jpg',
    showPartnerModal: false,
    modalShowLogo: true
  },
  thinkmoney: {
    prePopulateForm: false,
    affiliateUserId: 2319,
    displayName: 'Think Money',
    logoPath: '/img/thinkmoney/logo.png',
    showPartnerModal: false,
    modalShowLogo: true,
		theme: 'thinkmoney',
    themeColor: '#474747'
  },
  thinkmoneycar: {
    prePopulateForm: false,
    affiliateUserId: 21886
  },
  totallymoney: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-16',
    affiliateUserId: 2439,
    displayName: 'Totally Money',
    logoPath: '/img/totallymoney/totallymoney.svg',
    showPartnerModal: false,
    modalShowLogo: true,
    theme: 'totallymoney',
    themeColor: '#0f0a3a'
  },
  youngcardriver: {
    prePopulateForm: true,
    googleAnalytics: 'UA-219881-16',
    affiliateUserId: 2400,
    displayName: 'Young Car Driver',
    logoPath: '/img/youngcardriver/young-car-driver.png',
    showPartnerModal: false,
    modalShowLogo: true
  }
}
